import { Select } from '@/components/Select';

export const TENANT_ROLES = ['USER', 'MANAGER', 'LEAD', 'ADMIN', 'NONE'] as const;

export function RoleSelect({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  return (
    <Select value={value} onChange={(e) => onChange(e.target.value)}>
      {TENANT_ROLES.map((r) => (
        <option key={r} value={r}>
          {r}
        </option>
      ))}
    </Select>
  );
}
